<template>
  <div>
  <v-autocomplete
    :items="items_list"
    v-model="val"
    :label="label"
    item-text="title"
    clearable
    item-value="id"
    :disabled="items.length == 0 || !loaded"
  ></v-autocomplete>
</div>
</template>

<script>
import {EventMixin} from '@/lib/mixins.js';
import Vue from 'vue';
import EventExternalModel from '@/models/event_external.js'
import datelib from '@/lib/date.js';

export default {
  mixins: [EventMixin],
  props: [
    'value',
    'label',
    'name',
    'content_id',
    'from',
    'from_key'
  ],
  data () {
    return {
      items: [],
      loaded: false
    }
  },
  watch: {
    "from_data": function () {
      this.load_data();
    }
  },
  created () {
    this.load_data();
  },
  methods: {
    load_data () {
      var self = this;

      if (this.content_id == "cards") {
        let api_url = "https://httpsproxy.kepit.fi/veikkaus/api/toto-info/v1/cards/active"

        fetch(api_url)
          .then((response) => {
            // Technical processing
            if(!response.ok) { throw response.status }

            return response.json()
          })
          .then((response) => {
            // Content processing
            self.items = _.map(_.get(response, "collection", []), (card) => {
              var st = card["epgStartTime"] / 1000;
              var d = datelib.format_date(st) + " - " + datelib.format_time(st);
              var title = d + " | " + card["trackName"];
              return {
                id: card["cardId"],
                title: title,
                start_time: card["epgStartTime"],
                end_time: card["epgEndTime"]
              }
            });

            self.loaded = true;
          })
          .catch((error) => {
            console.error("TotoTV API cards fetch failed", error)

            self.loaded = true
          })

      } else if (this.content_id == "race") {
        var card_id = self.from_data;
        console.log("Loading races", card_id);

        if (typeof(card_id) == "undefined") {
          return;
        }

        let api_url = "https://httpsproxy.kepit.fi/veikkaus/api/toto-info/v1/card/" + card_id + "/races"

        fetch(api_url)
          .then((response) => {
            // Technical processing
            if(!response.ok) { throw response.status }

            return response.json()
          })
          .then((response) => {
            // Content processing
            self.items = _.map(_.get(response, "collection", []), (card) => {
              var title = "" + card["number"]
              return {
                id: card["raceId"],
                title: title,
              }
            });

            console.log(self.items);
            self.loaded = true;
          })
          .catch((error) => {
            console.error("Sanoma API races fetch failed", error)

            self.loaded = true
          })
      } else if (this.content_id == "runner") {
        var race_id = self.from_data;
        console.log("Loading runners", race_id);

        if (typeof(race_id) == "undefined") {
          return
        }

        let api_url = "https://httpsproxy.kepit.fi/veikkaus/api/toto-info/v1/race/" + race_id + "/runners"

        fetch(api_url)
          .then((response) => {
            // Technical processing
            if(!response.ok) { throw response.status }

            return response.json()
          })
          .then((response) => {
            // Content processing
            self.items = _.map(_.get(response, "collection", []), (card) => {
              var title = "" + card["startNumber"] + " " + card["horseName"];
              return {
                id: card["runnerId"],
                title: title,
              }
            });

            console.log(self.items);
            self.loaded = true;
          })
          .catch((error) => {
            console.error("Sanoma API runners fetch failed", error)

            self.loaded = true
          })
      }
    }
  },
  computed: {
    from_data () {
      if(!this.from) return undefined;
      return _.get(this.value, this.from);
    },
    items_list () {
      return this.items;
    },
    val: {
      get () {
        return _.get(this.value, this.name);
      },
      set (val) {
        var value = _.cloneDeep(this.value);
        _.set(value, this.name, val);
        this.$emit("input", value);
      }
    }
  }
}
</script>
